import { GETWORKSPACEMEMBER_SUCCESS, GETWORKSPACEMEMBER_FAIL, WORKSPACEID_DATA } from '../actionTypes';

const initialState = {
    user: null,
    workspaceIdData: null
};

const getWorkspaceMemberReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETWORKSPACEMEMBER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETWORKSPACEMEMBER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        case WORKSPACEID_DATA:
            return {
                ...state,
                workspaceIdData: action.payload
            }
        default:
            break;
    }

    return state;
};

export default getWorkspaceMemberReducer;
